module.exports = __webpack_public_path__ + "static/media/winterBg.a99c1799.jpeg";